import { SideNavMenu } from '@side/pantry';
import type { SideComponentProps } from 'src/common/types/app';
import { PageTitle } from '@/components/PageTitle/PageTitle';
import { Home } from '@/views/Home';

const HomePage: SideComponentProps = () => {
  return (
    <>
      <PageTitle title="Home Page | Side" />
      <Home />
    </>
  );
};

HomePage.appShellProps = {
  hideInteractionSidebar: true,
  defaultExpandedSubmenu: SideNavMenu.TRANSACTIONS,
};

HomePage.disableInteractionValidation = true;

export default HomePage;
